<template>
  <div class="price-table-dark-app vn-landing--midnight">
    <section class="vn-landing__box">
      <ul class="vn-landing__badges">
        <li>평생소장</li>
        <li>최저가</li>
      </ul>
      <h4 class="vn-landing__title">{{ productTitle }}</h4>
      <ul class="vn-landing__guide" v-if="discountPercent">
        <li>현재 정가 대비 {{ discountPercent }}% 할인 중!</li>
        <li v-if="productSaleDueDate">{{ productSaleDueDate }} 까지</li>
      </ul>
      <ul class="vn-landing__columns">
        <li class="vn-landing__column">
          <span class="vn-landing__type">정상가</span>
          <span class="vn-landing__price">{{ listPrice }}원</span>
        </li>
        <li class="vn-landing__column" v-if="productDiscountAmount">
          <span class="vn-landing__type">할인 금액</span>
          <span class="vn-landing__price">-{{ productDiscountAmount }}원</span>
        </li>
        <li class="vn-landing__column">
          <span class="vn-landing__type--light">최종 금액</span>
          <span class="vn-landing__price--light">{{ salePrice }}원</span>
        </li>
        <li class="vn-landing__column" v-if="splitPrice">
          <span class="vn-landing__type"><strong>12개월 할부 시</strong></span>
          <span class="vn-landing__price">
            <strong>월 {{ splitPrice }}원</strong>
          </span>
        </li>
      </ul>
      <div class="vn-landing__button">
        <a :href="`/products/${productId}`" class="btn">{{ buttonLabel || '수강 신청하기' }}</a>
      </div>
    </section>
    <div class="vn-sheet__panel vn-landing__cards">
      <p class="vn-sheet__panel__p">국내 9개 카드사 12개월 무이자 할부 지원!</p>
      <ul class="vn-sheet__tags">
        <li>삼성카드</li>
        <li>신한카드</li>
        <li>롯데카드</li>
        <li>현대카드</li>
        <li>하나카드</li>
        <li>BC카드</li>
        <li>KB국민은행</li>
        <li>씨티카드</li>
        <li>NH농협카드</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'price-table-dark-app',
  props: [
    'courseId',
    'coursePageId',
    'discountPercent',
    'hasProducts',
    'saleDueDate',
    'listPrice',
    'productDiscountAmount',
    'productId',
    'productSaleDueDate',
    'productTitle',
    'salePrice',
    'splitPrice',
    'buttonLabel',
  ],
};
</script>
